import React, {useState} from 'react';
import Dialog from "@material-ui/core/Dialog";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import {compose} from "redux";
import {connect} from "react-redux";
import {closeConfirmationModal, openConfirmationModal, toggleLoading} from "../../redux/reducers/utils";
import * as _ from 'lodash';
import FdlOutlinedInput from "../../utils/FdlOutlinedInput/FdlOutlinedInput";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Tooltip from "@material-ui/core/Tooltip";
import routes from '../../utils/api-client';
import {navigate} from "@reach/router";
import {updateClient} from "../../redux/reducers/user";
import {DOCUMENT_CATEGORIES} from "../../config/constants";

function AddClientModal(props){

  let [activeStep, setActiveStep] = useState(1);
  let [name, setName] = useState('');
  let [email, setEmail] = useState('');
  let [phone, setPhone] = useState('');
  let [type, setType] = useState('INDIVIDUAL');
  let [notes, setNotes] = useState('');
  let [documentCategory, setDocumentCategory] = useState('INCOME');
  let [requestedDocuments, setRequestedDocuments] = useState([]);

  const stepTitles = ["Basic Details", "Request Documents", "Preview"]
  const stepDescriptions = ["Fill out information about the client.", "Choose the types of documents you need from the client.", "Preview and finalize."]


  const closeModal = () => {
    props.closeModal();
  }

  const addClient = () => {
    const data = {
      name: name,
      email: email,
      phone_number: phone,
      type: type,
      notes: notes,
      requested_documents: requestedDocuments
    }
    routes.createClient(data).subscribe((response) => {
      props.updateClient(response.data);
      props.closeModal();
      //
      navigate(`/clients/${response.data.id}`)
    })
  };

  const updateRequestedDocuments = (category) => {
    let newDocuments = [...requestedDocuments];
    const index = _.indexOf(newDocuments, category);
    if (index !== -1) {
      newDocuments = _.pull(newDocuments, category);
    } else {
      newDocuments.push(category);
    }
    setRequestedDocuments(newDocuments)
  }

  return (
    <Dialog open={props.openModal} onClose={closeModal} fullWidth={true} maxWidth={"md"} className={"add-client-modal"}>
      <div className="flex justify-between mb-4">
        <p className="text-3xl text-primary">Add a New Client</p>
        <div className="flex items-center">
          <div className={`step-indicator ${activeStep >= 1 ? 'active': ''}`}>{activeStep > 1 ? '✓' : 1}</div>
          <div className={`step-separator ${activeStep >= 2 ? 'active': ''}`}/>
          <div className={`step-indicator ${activeStep >= 2 ? 'active': ''}`}>{activeStep > 2 ? '✓' : 2}</div>
          {/*<div className={`step-separator ${activeStep >= 3 ? 'active': ''}`}/>*/}
          {/*<div className={`step-indicator ${activeStep >= 3 ? 'active': ''}`}>3</div>*/}
          <div className="cursor-pointer" onClick={props.closeModal}>
            <FontAwesomeIcon icon='times' className="text-grey ml-10"/>
          </div>
        </div>
      </div>
      <div className="flex w-full items-center">
        <div className="vaults-description-container mr-0 sm:mr-10">
          <p className="text-xl">{stepTitles[activeStep-1]}</p>
          <p className="text-grey text-sm">{stepDescriptions[activeStep-1]}</p>
        </div>
        <div className="section-divider mt-3 mb-5 sm:mt-0 sm:mb-0"/>
      </div>

      <div class="mt-4 mb-6">
        {
          activeStep === 1 &&
          <div>
            <div className="w-1/2">
              <FdlOutlinedInput value={name}
                                label={"Full Name"}
                                autoFocus
                                validators={["required"]}
                                onChange={(value) => setName(value)} />
            </div>
            <div className="flex-1 mt-8">
              <FormControl className="w-1/2"
                           margin="dense"
                           variant="outlined">
                <InputLabel className="form-label-override"
                            required
                            shrink={true}>
                  Type
                </InputLabel>
                <Select value={type} onChange={(event)=> setType(event.target.value)}>
                  <MenuItem value={"INDIVIDUAL"}>Individual</MenuItem>
                  <MenuItem value={"FAMILY"}>Family</MenuItem>
                  <MenuItem value={"BUSINESS"}>Business</MenuItem>
                  <MenuItem value={"OTHER"}>Other</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="w-1/2 mt-8">
              <FdlOutlinedInput value={email}
                                label={"Email Address"}
                                validators={["email", "required"]}
                                options={{}}
                                onChange={(value) => setEmail(value)} />
            </div>
            <div className="w-1/2 mt-10">
              <FdlOutlinedInput value={phone}
                                label={"Phone Number"}
                                validators={[]}
                                options={{}}
                                onChange={(value) => setPhone(value)} />
            </div>

            <div className="mt-10 ">
              <FdlOutlinedInput value={notes}
                                label={"Notes"}
                                rows={5}
                                validators={[]}
                                options={{}}
                                onChange={(value) => setNotes(value)} />
            </div>
          </div>
        }

        {
          activeStep === 2 &&
            <div>
              {
                _.map(Object.keys(DOCUMENT_CATEGORIES), category =>
                  <Button
                    className={`document-category-container w-2/3 ${_.includes(requestedDocuments, category) && 'active'}`}
                    onClick={() => updateRequestedDocuments(category)}>
                    <div className="flex justify-between items-center w-full text-left">
                      <div>
                        <p className="text-lg mb-2">{DOCUMENT_CATEGORIES[category].title}</p>
                        <p className="">{DOCUMENT_CATEGORIES[category].description}</p>
                      </div>
                      {
                        !_.includes(requestedDocuments, category) ?
                          <FontAwesomeIcon icon={'ban'} size="lg"/>
                          :
                          <FontAwesomeIcon icon={'check'} size="lg" className="text-secondary"/>
                      }
                    </div>
                </Button>)
              }

              <Tooltip enterTouchDelay={50} placement={"right"} title={"If you need to request additional document categories, contact support for assistance."}>
                <div className="flex items-center mt-2">
                  <FontAwesomeIcon icon={"question-circle"} className={"cursor-pointer text-secondary"}/>
                  <p className="text-xs sm:text-sm text-grey ml-2">Need additional categories?</p>
                </div>
              </Tooltip>
            </div>
        }
      </div>
      <Divider className="mt-10"/>
      <div className="flex justify-end mt-3">
        {
          activeStep > 1 &&
          <div className="mr-3">
            <Button
              variant="outlined"
              color=""
              onClick={() => setActiveStep(activeStep - 1)}>Previous</Button>
          </div>
        }
        {
          activeStep === 2 ?
            <Button
              variant="outlined"
              color="primary"
              onClick={() => addClient()}>Save</Button>
            :
            <Button
              variant="outlined"
              color="primary"
              disabled={activeStep === 1 && !(name && email)}
              onClick={() => setActiveStep(activeStep + 1)}>Next</Button>
        }
      </div>

    </Dialog>
  );
}


export default compose(
  connect(
    null,
    { updateClient }
  )
)(AddClientModal);
